var $ = require('jquery');
var _ = require('underscore');
var stringUtils = require('./../../../utils/stringUtils');
var TorsoFormView = require('backbone-torso/modules/FormView');
var searchTemplate = require('./searchTemplate.hbs');

/**
 * View to handle searching for BrecTable.
 *
 * @class SearchView
 * @constructor
 * @param options {Object} passed in options and the tableState from the parent view.
 *   @param options.tableState {Torso.Cell} the shared state of the widget (filters, search, paging, fetching... etc.).
 *   @param [options.ariaControls=''] {String} the id of the table associated with this widget.
 */
module.exports = TorsoFormView.extend({
  tagName: 'form',
  className: 'brec-searchbox',
  attributes: function() {
    return {
      'aria-controls': this._ariaControls,
      'aria-label': $.i18n.prop('widget.search.arialLabel')
    };
  },
  template: searchTemplate,

  events: {
    'keyup [data-search-input]': '_pushSearch',
    'click [data-js-search]': '_pushSearch',
    'click [data-js-clear-search]': '_clearSearch',
    'submit': '_preventSubmitDefault'
  },

  feedback: [{
    //******** Search *********
    /**
     * On keyup on the search field, display the option to clear the parameters.
     * Also fire it to reset when the clear search button has been clicked.
     * @property feedback[0] (Search Message) {When/Then Feedback}
     */
    when: {
      '@search' : ['keyup'],
      listenTo: [{object: 'model', events: 'change:search'}]
    },
    then: function() {
      var searchString = stringUtils.nullSafeTrim(this.model.get('search'));

      if (searchString.length > 0) {
        return {
          text: $.i18n.prop('widget.search.clear.label'),
          removeClass: 'brec-hidden',
          attr: [{'aria-hidden': false}]
        };
      } else {
        return {
          text: '',
          addClass: 'brec-hidden',
          attr: [{'aria-hidden': true}]
        };
      }
    },
    to: 'searchClear'
  }],

  /**
   * @method constructor
   * @param options {Object} passed in options and the tableState from the parent view.
   *   @param options.tableState {Torso.Cell} the shared state of the widget (filters, search, paging, fetching... etc.).
   *   @param [options.ariaControls=''] {String} the id of the table associated with this widget.
   *   @param [options.placeholderMessageKey] {String} the message key for the search placeholder
   * @override
   */
  constructor: function(options) {
    var defaultOptions = {
      tableState: null,
      placeholderMessageKey: 'widget.search.placeholder',
      ariaControls: ''
    };
    options = _.defaults({}, options, defaultOptions);
    this._ariaControls = options.ariaControls;

    TorsoFormView.apply(this, arguments);

    this._tableState = options.tableState;
    this._placeholderMessageKey = options.placeholderMessageKey;

    this.model.setMapping('tableState', 'search', this._tableState, true);
    this.listenTo(this._tableState, 'change:search', this._pullSearch);
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var templateContext = TorsoFormView.prototype.prepare.apply(this);
    templateContext.tableState = this._tableState.toJSON();
    templateContext.placeholderMessageKey = this._placeholderMessageKey;
    return templateContext;
  },

  /**
   * Set the search locally on this view.
   * @method _pullSearch
   * @private
   */
  _pullSearch: function() {
    this.model.pull();
  },

  /**
   * Prevents a form submission so that the page does not reload.
   * Pushing search parameters is taken care of by click and keyup event handlers.
   * @method _preventSubmitDefault
   * @param event
   * @private
   */
  _preventSubmitDefault: function(event) {
    event.preventDefault();
  },

  /**
   * Submit the search parameters to the parent through the
   * EventBus to affect the other views.
   *
   * @method _pushSearch
   * @private
   */
  _pushSearch: function(event) {
    if (event.type === 'click' || (event.type === 'keyup' && event.keyCode === 13)) {
      // Deactivate table while potentially making changes to paging & search
      this._tableState.set('active', false);

      // Reset to the first page if the search changes to prevent hitting empty pages.
      if (this._tableState.get('search') !== this.model.get('search')) {
        this._tableState.set('page', 1);
      }
      this.model.push();
      this._tableState.set('active', true);
    }
  },

  /**
   * Reset the search parameters and call an "unsearch" giving us back the default
   * results as if we had not searched.
   *
   * @method _clearSearch
   * @private
   */
  _clearSearch: function() {
    this.model.set('search', '');
    this.model.push();
  }
});
